///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.unsolicited = abcsetup.consumer_rfp.unsolicited || {};
abcsetup.consumer_rfp.unsolicited.workflow = abcsetup.consumer_rfp.unsolicited.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.unsolicited.workflow = {

    supplierContractEditor: null,

    init: function () {

        abcsetup.setTitle('Unsolicited Bid');

        this._setupRejectButton();
        this._setupBindings();
        this._setupAwardRejectButtons();
        this._resetBidStatus();
        this._awardBid();
        this._rejectBid();

        CKEDITOR.create($('#contract')[0], CKEDITOR.config).then(editor => {
            abcsetup.consumer_rfp.unsolicited.workflow.supplierContractEditor = editor;
        });

        $(document).on('click', '.reset-to-default-btn', function(event) {
            abcsetup.consumer_rfp.unsolicited.workflow.supplierContractEditor.setData($(event.target).data('defaultContract') || '')
        });

        // Init the common lib
        abcsetup.consumer_rfp.unsolicited.common.init();
    },

    fieldError: function () {
        abcsetup.unblockUI();
        var errorField = $('form').find('.invalid').first();

        if (!errorField.is(':visible')) {
            var itemPanel = errorField.closest('.card-body');
            itemPanel.closest('.card').find('.card-header').trigger('click');
        }
    },

    /**
    * When reject button is clicked, ask for some info.
    */
    _setupRejectButton() {
        $('#btn-reject').on('click', event => {
            console.log("Reject button clicked");
            event.preventDefault();
            const form = event.target.form;

            const handleClose = function (resp) {
                if (resp[0]) {
                    $('#reject_reason').val(resp[1]);
                    $('#btn-reject').off('click').trigger('click');
                }
            }

            abcsetup.alerts.prompt('Reject Consumer RFP Unsolicited Bid', 'Reason for rejection:', handleClose, false, false, { textarea: true })
        });
    },

    _setupBindings() {
        // Toggle whether samples were received.
        $(document).on('click', '.btn_samples_received', event => {
            const button = $(event.target).closest('.btn_samples_received');
            console.log(button);
            const bidId = button.data('bidId');
            const badge = $('[href="#' + bidId + '"] .badge-samples');
            if (!bidId) {
                console.error('No bid ID given on element: ', event.target);
            }

            abcsetup.blockUI(true);

            axios.put(`/api/consumer_rfp/bids/${bidId}/samples_received`, {
                were_received: button.data('wereReceived') ? 0 : 1, // toggling whether they were received.
            }).then(({ data }) => {
                button.data('wereReceived', button.data('wereReceived') ? 0 : 1); // update what the button is reporting as the received state internally.
                button.html(button.data('wereReceived') ? '<i class="fas fa-toggle-on"></i>' : '<i class="fas fa-toggle-off"></i>'); // set button content based on current received state.
                button.toggleClass('text-success', button.data('wereReceived')); // Set button text based on received state.
                const newButtonTitle = button.data('wereReceived') ? 'Samples received: ' + moment(data.samples_received_at).format('MMMM Do YYYY h:mm a') : '';
                button.attr('title', newButtonTitle); // Add received date to button, if we have one.
                button.attr('data-original-title', newButtonTitle); // Add received date to button, if we have one.
                console.log("were received: ", button.data('wereReceived'));
                if (button.data('wereReceived') == 1) {
                    button.attr('data-were-received', '1');
                    console.log("test", badge);
                    badge.removeClass('badge-warning').addClass('badge-success');
                    badge.html('Samples Received');
                } else {
                    button.attr('data-were-received', '0');
                    badge.removeClass('badge-success').addClass('badge-warning text-white');
                    badge.html('Pending Samples');
                }
                abcsetup.unblockUI();
            });
        });
    },

    /**
     * Setup the bindings for approving and rejecting individual bids.
     *
     * @private
     */
    _setupAwardRejectButtons() {
        $(document).on('click', 'label.award_btn,label.reject_btn', event => {
            event.preventDefault();
            const awardRejectButton = $(event.target).closest('label');
            const wasAlreadyChecked = awardRejectButton.find('input').prop('checked');

            if (wasAlreadyChecked) { // Unchecking a checked checkbox. Work is already done for this action.
                this._resetBidStatus(awardRejectButton.closest('tr'));
                return;
            }

            if (awardRejectButton.hasClass('btn-outline-success')) {
                this._awardBid(awardRejectButton.closest('tr'));
            } else {
                this._rejectBid(awardRejectButton.closest('tr'));
            }
        });

        // Initialize rows.
        $('#bid-review-table-container .datatable').on('draw.dt', (event, settings, json) => {
            $('.bid-status-toggle').each(event => {
                const activeButton = $(event.target).find('.active');
                const row = $(event.target).closest('tr');

                if (activeButton.hasClass('btn-outline-success')) {
                    return this._awardBid(row, true);
                } else if (activeButton.hasClass('btn-outline-danger')) {
                    return this._rejectBid(row, true);
                }

                this._resetBidStatus(row, true);
            });
        });
    },

    /**
     * Reset the given row's approval status.
     *
     * @param row
     * @param initialRun
     * @private
     */
    _resetBidStatus(row, initialRun = false) {
        const bidStatusToggle = $(row).find('.bid-status-toggle');

        bidStatusToggle.find('label').removeClass('active');
        bidStatusToggle.find('input')
            .prop('checked', false)
            .trigger('change', { revalidate: !initialRun });

        $(row).removeClass('award done reject')
            .find('.hidden-for-reject')
            .removeClass('hidden-for-reject')
            .parents('.cell-container')
            .children()
            .show();
        $(row).find('[name*=rejection_comments]')
            .parents('.cell-container')
            .children()
            .hide();

    },

    /**
     * Award the bid in the given row.
     *
     * @param row
     * @param initialRun
     * @private
     */
    _awardBid(row, initialRun = false) {
        const awardButton = $(row).find('.bid-status-toggle .btn-outline-success');

        this._resetBidStatus(row);

        awardButton.addClass('active');
        awardButton.find('input')
            .prop('checked', true)
            .trigger('change', { revalidate: true });

        $(row).removeClass('reject').addClass('done award');

        if (!initialRun) {
            const bidStatusToggle = awardButton.closest('.bid-status-toggle');
            // Mark the same item for other suppliers as rejected.
            $(`.bid-status-toggle.item_${bidStatusToggle.data('consumer_rfp_item_id')} .award_btn:has(input[type=radio]:checked)`)
                .not(awardButton)
                .toArray()
                .map(awardButton => $(awardButton).closest('.bid-status-toggle').find('.reject_btn'))
                .forEach(rejectButton => rejectButton.trigger('click'));
        }

    },

    /**
     * Reject the bid in the given row.
     *
     * @param row
     * @param {boolean} initialRun
     * @private
     */
    _rejectBid(row, initialRun = false) {
        const $row = $(row);
        const rejectButton = $row.find('.bid-status-toggle .btn-outline-danger');

        this._resetBidStatus(row);

        rejectButton.addClass('active');
        rejectButton.find('input')
            .prop('checked', true)
            .trigger('change', { revalidate: true });

        $row.removeClass('award').addClass('done reject')
            .find(':input:visible:not([name*=consumer_rfp_bid_status_id],[name*=rejection_comments]),.select2-hidden-accessible')
            .parents('.cell-container')
            .children()
            .addClass('hidden-for-reject')
            .hide()
        $row.find('[name*=rejection_comments]')
            .parents('.cell-container')
            .children()
            .show();

    },
}